import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { GetOpsService } from "../../services/get_ops/get-ops.service";
import { HomePage } from 'src/app/home/home.page';

@Component({
  selector: 'app-rechazar-sol',
  templateUrl: './rechazar-sol.component.html',
  styleUrls: ['./rechazar-sol.component.scss'],
})

export class RechazarSolComponent implements OnInit {
  @Input() onRefresh?: () => void;

  constructor(
    public api: ApiService,
    public ops: GetOpsService
  ) { }

  ngOnInit() { }
  
  rechazarSolicitudApi() {
    this.api.popoverController.dismiss();
    console.log('Rechazando solicitud...');

    const body={
      usuario:this.api.user.Usuario.trim(),
      numsol:this.api.solRechazo.NumSol,
      obs:this.api.motivoRechazo
    };

    console.log(body);

    this.api.req('post', 'putrechazosol', body, `Rechazando solicitud ${this.api.solRechazo.NumSol}...`).then((res: any) => {
      console.log('res', res);
      
      this.api.presentToast(res.res);
      this.onRefresh?.();

      // this.ops.getRunCredits2();
      // this.api.getEncPensionesF();
    }).catch((err) => {
      this.api.presentAlert('Error', 'Al rechazar solicitud', JSON.stringify(err));
    })
  }
}